"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Generates an alphanumeric string of a specified character length (defaults to 16 characters).
 *
 * @example
 * import createId from '@carvana/futilities/createId';
 * createId()
 * // () => '23b0sh3a2bhbqqng'
 * createId(3)
 * // () => '3by'
 */
function createId(len, charSet) {
    if (len === void 0) { len = 16; }
    if (charSet === void 0) { charSet = 'abcdefghijklmnopqrstuvwxyz0123456789'; }
    var text = '';
    var count = len;
    var charSetLength = charSet.length;
    while (count--) {
        text += charSet.charAt(Math.floor(Math.random() * charSetLength));
    }
    return text;
}
exports.default = createId;
//# sourceMappingURL=createId.js.map